import { useState, useEffect } from 'react';
import get from 'lodash/get';
import set from 'lodash/set';
import remove from 'lodash/remove';

import { getDefaultDictionaryValue, isWarehouseUsedMoreThanOne } from '../../utils';

export const FIELD_PATH = 'settings.warehouse_website_map';
export const WAREHOUSE_PATH = 'settings.default_warehouse_id';

export const useWebsites = ({ dictionaries, formData, onChangeField }) => {
    const [websiteMapError, setWebsiteMapError] = useState(false);

    useEffect(() => {
        setWebsiteMapError(
            isWarehouseUsedMoreThanOne({
                list: get(formData, FIELD_PATH, []),
                label: 'website_id',
            }),
        );
    }, [formData]);

    useEffect(() => {
        const warehouseDictionaryDefaultValue = getDefaultDictionaryValue({
            dictionary: get(dictionaries, 'warehouses', []),
        });
        if (warehouseDictionaryDefaultValue) {
            onChangeField({
                name: WAREHOUSE_PATH,
                value: warehouseDictionaryDefaultValue,
            });
        }
    }, [get(dictionaries, 'warehouses', [])]);

    const handleAddPair = () => {
        const warehouseDictionaryDefaultValue = getDefaultDictionaryValue({
            dictionary: get(dictionaries, 'warehouses', []),
        });

        const websitesDictionaryDefaultValue = getDefaultDictionaryValue({
            dictionary: get(dictionaries, 'websites', []),
        });

        const warehouseWebsiteMap = get(formData, FIELD_PATH, []).concat({
            warehouse_id: warehouseDictionaryDefaultValue,
            website_id: websitesDictionaryDefaultValue,
        });

        onChangeField({
            name: FIELD_PATH,
            value: warehouseWebsiteMap,
        });
    };

    const handleRemovePair = (key) => {
        const warehouseWebsiteMap = remove(get(formData, FIELD_PATH, []), (value, index) => index !== key);

        onChangeField({
            name: FIELD_PATH,
            value: warehouseWebsiteMap,
        });
    };

    const handleChangeField = (key, fieldName, value) => {
        const warehouseWebsiteMap = get(formData, FIELD_PATH, []);
        set(warehouseWebsiteMap, `${key}.${fieldName}`, value);

        onChangeField({
            name: FIELD_PATH,
            value: warehouseWebsiteMap,
        });
    };

    return {
        websiteMapError,
        handleAddPair,
        handleRemovePair,
        handleChangeField,
    };
};
